export * from '@fhs/routing/src/routes/(product)/_layout';
export { default } from '@fhs/routing/src/routes/(product)/_layout';
